import './src/styles/global.css';

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    setTimeout(() => {
      const element = document.getElementById(location.hash.replace('#', ''));

      if (element) {
        const headerHeight =
          document.getElementById('main-header')?.offsetHeight ?? 0;

        window.scrollTo({
          top:
            element.getBoundingClientRect().top +
            window.scrollY -
            headerHeight -
            20,
          behavior: 'smooth',
        });
      }
    }, 0);

    return false;
  }

  return true;
};
